import { ContentDirection } from '@design-system/types';
import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

import { useCurrentLang } from '~/hooks/useCurrentLang';

import { ContentDirectionHookQuery, UseContentDirectionHook } from './models';

export const useContentDirection: UseContentDirectionHook =
  (): ContentDirection => {
    const {
      currentLang: { locale: currentLangCode },
    } = useCurrentLang();

    const {
      allContentstackSettings: { nodes: settingsNodes },
    } = useStaticQuery<ContentDirectionHookQuery>(
      graphql`
        query ContentDirection {
          allContentstackSettings {
            nodes {
              defaultLocale: default_locale
              rtl
              tags
            }
          }
        }
      `
    );

    return useMemo(() => {
      const settings = settingsNodes.find(
        ({ tags, defaultLocale }) =>
          tags.includes(process.env.GATSBY_CONTENTSTACK_BRAND_TAG as string) &&
          defaultLocale.toLowerCase() === currentLangCode
      );

      return settings?.rtl ? ContentDirection.RTL : ContentDirection.LTR;
    }, [settingsNodes, currentLangCode]);
  };
